import { LinkButton } from '@app/components';
import { TSocialNetworks } from '@app/models';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import './social-networks.scss';

export type SocialNetworksProps = {
  model?: TSocialNetworks;
  className?: string;
};

export const SocialNetworks: FC<SocialNetworksProps> = ({ model, className }) => {
  const { t } = useTranslation();
  if (!model) {
    return null;
  }
  return (
    <div className={cx(className, 'social-networks')}>
      {Object.entries(model).map(
        ([name, link]) =>
          !!link && (
            <LinkButton externalLink className="social-networks__link" key={name} to={link} invertColors>
              {t(`contacts.socialMedia.${name}`)}
            </LinkButton>
          ),
      )}
    </div>
  );
};
